import { render } from "./NewBladeModelModal.vue?vue&type=template&id=7270511a&scoped=true&ts=true"
import script from "./NewBladeModelModal.vue?vue&type=script&lang=ts"
export * from "./NewBladeModelModal.vue?vue&type=script&lang=ts"

import "./NewBladeModelModal.vue?vue&type=style&index=0&id=7270511a&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7270511a"]])

export default __exports__